import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import CloseIcon from '@material-ui/icons/Close';

import BannerImageFull from './media/banner.png';

const styles = theme => {return {
  dialog: {
    zIndex: 50000,
  },
  transparent: {
    position: 'relative',
    backgroundColor: 'rgba(0,0,0,0)',
    boxShadow: 'none',
    outline: 'none',
    '&:hover': {
      outline: 'none',
    }
  },
  closeButton: {
    right: '0px',
    top: '0px',
    position: 'absolute',
    width: '0.2em'
  },
  dialogText: {
    textAlign: 'center',
  },
  titleName: {
    ...theme.typography.button,
    color: '#1e3685'
  },
  media: {
    height: 0,
    paddingTop: '25%', // 16:9
  },
}}

class SimpleDialog extends React.Component {
  handleClose = () => {
    this.props.onClose();
  };

  render() {
    const { classes, onClose, selectedValue, ...other } = this.props;

    return (
      <Dialog
        onClose={this.handleClose}
        aria-labelledby="simple-dialog-title"
        className={classes.dialog}
        PaperProps={{classes, className: classes.transparent}}
        {...other}>
        <Button
              color='primary'
              className={classes.closeButton}
              onClick={() => this.handleClose()}
          >
            <CloseIcon />
          </Button>
            <img src={BannerImageFull} />
      </Dialog>
    );
  }
}

const SimpleDialogWrapped = withStyles(styles)(SimpleDialog);

class Banner extends React.Component {
  state = {
    open: true,
  };

  handleClose = () => {
    window.localStorage.setItem('dontShowBanner', true)
    this.setState({ open: false });
  };

  render() {
    const dontShowBanner = window.localStorage.getItem('dontShowBanner')
    return (
        dontShowBanner === 'true' ? null :
        <SimpleDialogWrapped
          open={this.state.open}
          onClose={this.handleClose}
        />
    );
  }
}

export default Banner;


// WEBPACK FOOTER //
// ./src/Banner.js